import { h } from 'preact';
import StockInfoTable from '../stock-info-table';
import { Text } from 'preact-i18n';
import { FinanceSpinner } from '../glyphs';
import style from './style';
import cx from 'classnames';

export default function Competitors ({ data, pending, ...props }) {
	//show a spinner while the data is loading
	if (pending) return <FinanceSpinner />;

	let noData = !pending && !(data && data.rows && data.rows.length);

	return (
		<div class={cx(style.competitors, noData && style.dataUnavailable)}>
			{ noData ? <Text id="competitorsUnavailable" />  :

				<StockInfoTable
					dataTable
					showHeaders
					columns={[
						'competitors',
						'price',
						'changeCompound',
						'marketCap'
					]}
					data={data}
					{...props}
				/>
			}
		</div>
	);
}



// WEBPACK FOOTER //
// ../node_modules/@cube/finance-components/src/components/company-profile/competitors.js